import React from "react";
import { Link } from "react-router-dom";

import { classDataPath } from "../../../teacherStore";
import Button from "../../../atoms/ActiveLearning/Button";

import styles from "./SelectDataPage.module.scss";

export default () => {
  return (
    <div className={styles.wrapper} id="accordion">
      <div className={styles.container}>
        <p className={styles.title}>データを見たい教材を選んでください</p>
        <div className={styles.buttonWrapper}>
          <Link className={styles.link} to={classDataPath}>
            <Button width={"100%"}>BASE/CORE基礎編</Button>
          </Link>
          <Link
            className={styles.link}
            to={`${classDataPath}?isActiveLearning=true`}
          >
            <Button width={"100%"}>CORE実践編</Button>
          </Link>
        </div>
      </div>
    </div>
  );
};
